module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/projects-stronglist-support.json
// module id = 335
// module chunks = 98767858357558